module.exports = __webpack_public_path__ + "img/Meca_Chantier_CD_016.2e662266.jpg";